module.exports = __webpack_public_path__ + "static/media/reg_tabAccount_hide.e013b7a4.svg";